/**
 * Apples to Apples' three screens. The server entry must never import from here (it
 * would drag React into the server build); `@gsf/kit` is the only client module
 * importable, and one game's UI must not import another's.
 */

import type { GameUi } from '@gsf/kit';
import { ApplesDisplay } from './display';
import { ApplesHost } from './host';
import { ApplesPlayer } from './player';

export const applesUi: GameUi = {
  host: ApplesHost,
  display: ApplesDisplay,
  player: ApplesPlayer,
};

export { ApplesDisplay, ApplesHost, ApplesPlayer };
export { applesAsks, applesView, type ApplesView } from './view';
